export default __webpack_public_path__ + "static/media/strawberries.0090ff1a.jpg";